// extracted by mini-css-extract-plugin
export var navbarSubLink = "w_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "w_s4 d_f0 d_dB";
export var subPageLink = "w_gf d_gf";
export var burger = "w_tw";
export var sublinkSize = "w_tx";
export var linkSize = "w_ty";
export var Link = "w_rg p_rg p_qt p_qP";